import { EventEmitter, Injectable } from "@angular/core";
import { AngularFirestore } from "@angular/fire/firestore";
import { from } from "rxjs";
import { map } from "rxjs/operators";
import { ComptonSchool } from "./dummy-data";
import { ISchool } from "./models";

@Injectable({
  providedIn: "root",
})
export class SchoolsService {

  private readonly colName: string = "schools";

  constructor(private readonly db: AngularFirestore) {
  }

  public getAll() {
    // return from([[ComptonSchool]]);
    return this.db.collection(this.colName).snapshotChanges()
      .pipe(
        map((actions: any) => actions.map(a => {
          const data = a.payload.doc.data();
          const id = a.payload.doc.id;
          return { id, ...data };
        }))
      );
  }

  create(value: ISchool): Promise<any> {
    return this.db.collection(this.colName).add(value);
  }

  update(key: string, value: ISchool): Promise<void> {
    return this.db.collection(this.colName).doc(key).set(value);
  }

  public createTestSchool(): Promise<any> {
    const compton: ISchool = ComptonSchool;
    return this.create(compton);
  }
}
